module.exports = __webpack_public_path__ + "static/img/thumbsup.90ca0ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/models/track/textures/emojis/thumbsup.png
// module id = 522
// module chunks = 1